import React, { useEffect } from 'react';
import { styled } from '@compiled/react';

import { SpotlightTarget } from '@atlaskit/onboarding';

import { useSessionData } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition';
import { ActionMenu } from '@confluence/trial-components/entry-points/ActionMenu';
import { useWindowSize } from '@confluence/dom-helpers';
import { useCanUpgradeAndPayForProductUser } from '@confluence/experiment-more-product-users-can-upgrade-pay';
import { fg } from '@confluence/feature-gating';
import {
	useAutoUpgradeAwareness,
	AutoUpgradeAwarenessFreePill,
} from '@confluence/experiment-auto-upgrade-awareness';
import { PersistentUpgradeButton } from '@confluence/persistent-upgrade/entry-points/PersistentUpgradeButton';

import { useEditionAwarenessDataQueries } from './useDataQueries';
import { EditionAwarenessAudienceTimingChecker } from './AudienceTimingChecker';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'none',
	'@media (min-width: 680px)': {
		display: 'initial',
	},
});

export const EditionAwareness = () => {
	const { edition } = useSessionData();
	const { width } = useWindowSize();

	const { isAUAVariantEnabled } = useAutoUpgradeAwareness();

	const isFreeEdition = edition === ConfluenceEdition.FREE;

	const isTrialEdition =
		edition === ConfluenceEdition.STANDARD || edition === ConfluenceEdition.PREMIUM;

	const shouldShowFreePUB = isFreeEdition;
	const shouldShowTrialEA = isTrialEdition;

	const isRefactorFFEnabled = fg('cc_edition_awareness_refactor_changes');
	const data = useEditionAwarenessDataQueries(!isRefactorFFEnabled);

	const { fireMpuExposure } = useCanUpgradeAndPayForProductUser();
	useEffect(() => {
		fireMpuExposure();
	}, [fireMpuExposure]);

	const renderFreeButton = () => {
		if (shouldShowFreePUB) {
			if (isAUAVariantEnabled) {
				return <AutoUpgradeAwarenessFreePill />;
			}

			return <PersistentUpgradeButton isInAppNavigation />;
		}
	};

	return (
		<SpotlightTarget name="edition-awareness">
			<Container>
				{renderFreeButton()}
				{shouldShowTrialEA && <ActionMenu shouldHidePopup={width <= 680} />}
				{isRefactorFFEnabled && <EditionAwarenessAudienceTimingChecker data={data} />}
			</Container>
		</SpotlightTarget>
	);
};
